import React from 'react';

import { ButtonWithIcon } from '@/components';
import { VideoIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type VideoCallButtonProps = {
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    disabled: boolean;
};

export const VideoCallButton = ({
    disabled,
    ...props
}: VideoCallButtonProps) => {
    return (
        <ButtonWithIcon
            icon={<VideoIcon />}
            variant="primary"
            disabled={disabled}
            {...props}
        >
            {R.ButtonCallVideo}
        </ButtonWithIcon>
    );
};
